import React from "react";
import BgImg from "../../../images/locationgcc/dxb/ae/tek_dubai_ae.png";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

function locationae({ Loc }) {
  return (
    <div
      className="location_ae p-100"
      style={{ backgroundImage: `url(${BgImg})` }}
    >
      <Container>
        <Row>
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
            <div className="map_ae">
              {Loc?.address === "DubaiPin" ? (
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d14456.051541526633!2d55.144309!3d25.0675524!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5f6daba25d1257%3A0xf8e37e969426072a!2sMobile%20App%20Development%20Company%20In%20Dubai%20%7C%20TekRevol!5e0!3m2!1sen!2s!4v1677473939803!5m2!1sen!2s"
                  width="100%"
                  allowFullScreen={true}
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Dubai Location Map"
                ></iframe>
              ) : Loc?.address === "UKPin" ? (
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2481.6701459499664!2d-0.20286849999999998!3d51.537609599999996!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xa833f7c8f654dc3f%3A0x42e4ad54f62f90e1!2sMobile%20App%20Development%20Company%20UK%20-%20TekRevol!5e0!3m2!1sen!2s!4v1708420237174!5m2!1sen!2s"
                  width="100%"
                  allowFullScreen={true}
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="UK Location Map"
                ></iframe>
              ) : null}
            </div>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto offset-xl-1 offset-lg-1"
          >
            <h2>{Loc?.title}</h2>
            <p>{Loc?.txt}</p>
            <div className="ae_loc_box">
              <ul>
                <li>
                  <svg
                    width="16"
                    height="21"
                    viewBox="0 0 16 21"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M10.7808 18.7005C13.0905 15.7551 16 11.4759 16 8.6087C16 3.85424 12.4183 0 8 0C3.58172 0 0 3.85424 0 8.6087C0 11.4759 2.90945 15.7551 5.21921 18.7005C6.42425 20.2371 7.02677 21.0055 8 21.0055C8.97323 21.0055 9.57575 20.2371 10.7808 18.7005ZM8 12C6.34315 12 5 10.6569 5 9C5 7.34315 6.34315 6 8 6C9.65685 6 11 7.34315 11 9C11 10.6569 9.65685 12 8 12Z"
                      fill="#2D264B"
                    />
                  </svg>
                  <span>{Loc?.location}</span>
                </li>
                <li>
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M5.41672 0.669995C4.44451 -0.223332 2.95015 -0.223332 1.97795 0.669995C1.93814 0.70658 1.89563 0.749094 1.84044 0.804301L1.01109 1.63365C0.176556 2.46818 -0.173775 3.67124 0.0822493 4.82336C1.53486 11.3601 6.6399 16.4651 13.1766 17.9177C14.3287 18.1738 15.5318 17.8234 16.3663 16.9889L17.1956 16.1596C17.2509 16.1044 17.2934 16.0619 17.33 16.022C18.2233 15.0498 18.2233 13.5555 17.33 12.5833C17.2934 12.5434 17.2509 12.5009 17.1956 12.4457L15.8379 11.088C14.8953 10.1453 13.4717 9.87574 12.2497 10.4084C11.5501 10.7134 10.7351 10.559 10.1954 10.0194L7.9806 7.80457C7.44094 7.26491 7.2866 6.44993 7.59156 5.75032C8.12424 4.52827 7.85465 3.10472 6.912 2.16208L5.55424 0.804314C5.49904 0.749102 5.45653 0.706584 5.41672 0.669995Z"
                      fill="#2D264B"
                    />
                  </svg>
                  <Link
                    to={`tel:${Loc?.tel}`}
                    className=" phone_btn_ae"
                    aria-label="TekRevol Contact"
                  >
                    {Loc?.tel}
                  </Link>
                </li>
              </ul>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default locationae;
